/* FBK productfoto's zoals Coolblue (27-09-2026). Opmaak in assets/fbk-gallery.css.
   Werkt bovenop de <product-gallery>/<media-carousel> van het thema (theme.js):
   - pijlknoppen [data-fbk-gal-prev]/[data-fbk-gal-next] roepen carousel.previous()/next() aan en verbergen zich aan de randen;
   - klik/tik op een foto opent de grote weergave via het thema-event "lightbox:open" (PhotoSwipe, pinch-zoom op mobiel);
     het thema-gedrag "klik links/rechts = vorige/volgende" wordt daarvoor in de capture-fase onderschept;
   - desktop met muis: hover = lens met de foto in hoge resolutie, ingezoomd op het punt onder de muis;
   - thumbnails: desktop max 7, mobiel max 5; de laatste wordt een "+N"-tegel die de grote weergave opent. */
(function () {
  if (window.fbkGalleryInit) return;
  window.fbkGalleryInit = true;

  var ZOOM = 2.5;
  var MAX_THUMBS_DESK = 7;
  var MAX_THUMBS_MOBILE = 5;
  var mqFine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var mqMobile = window.matchMedia('(max-width: 699px)');

  function isImageSlide(el) {
    return el && el.getAttribute('data-media-type') === 'image';
  }

  function openLightbox(gallery, slide) {
    if (!gallery.hasAttribute('allow-zoom')) return false;
    var slides = Array.prototype.filter.call(
      gallery.querySelectorAll('.product-gallery__media-list > .product-gallery__media[data-media-type="image"]'),
      function (m) { return !m.hidden; }
    );
    var index = slides.indexOf(slide);
    gallery.dispatchEvent(new CustomEvent('lightbox:open', { bubbles: true, detail: { index: index < 0 ? 0 : index } }));
    return true;
  }

  /* Grootste bron uit de srcset die nog zinvol is voor de lens */
  function hiResUrl(img, want) {
    var best = null, bestW = 0, fallback = img.currentSrc || img.src;
    (img.getAttribute('srcset') || '').split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var w = parseInt(bits[1], 10);
      if (!bits[0] || !w) return;
      if ((bestW < want && w > bestW) || (w >= want && w < bestW)) { best = bits[0]; bestW = w; }
    });
    return best || fallback;
  }

  function setup(gallery) {
    if (gallery.fbkGal) return;
    var carousel = gallery.querySelector('media-carousel');
    var wrapper = gallery.querySelector('.product-gallery__media-list-wrapper');
    if (!carousel || !wrapper) return;
    gallery.fbkGal = true;

    /* ---- Pijlen ---- */
    var prev = gallery.querySelector('[data-fbk-gal-prev]');
    var next = gallery.querySelector('[data-fbk-gal-next]');
    function updateArrows() {
      var visible = carousel.visibleItems || [];
      var i = visible.indexOf(carousel.selectedSlide);
      if (prev) prev.hidden = !(visible.length > 1 && i > 0);
      if (next) next.hidden = !(visible.length > 1 && i > -1 && i < visible.length - 1);
    }
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); carousel.previous(); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); carousel.next(); });
    gallery.addEventListener('carousel:change', function () { setTimeout(updateArrows, 0); });
    gallery.addEventListener('carousel:settle', updateArrows);
    carousel.addEventListener('carousel:filter', function () { setTimeout(function () { updateArrows(); layoutThumbs(); }, 0); });
    updateArrows();

    /* ---- Klik/tik op foto = grote weergave ---- */
    wrapper.addEventListener('click', function (e) {
      if (e.target.closest('button, a[href]')) return;
      var slide = e.target.closest('.product-gallery__media');
      if (!isImageSlide(slide)) return;
      if (openLightbox(gallery, slide)) {
        e.stopPropagation();
        endZoom();
      }
    }, true);

    /* ---- Hover-zoom (alleen muis) ---- */
    var zoomSlide = null;
    function lensFor(slide) {
      var lens = slide.querySelector(':scope > .fbk-gal-lens');
      if (!lens) {
        lens = document.createElement('div');
        lens.className = 'fbk-gal-lens';
        lens.setAttribute('aria-hidden', 'true');
        slide.appendChild(lens);
      }
      return lens;
    }
    function endZoom() {
      if (zoomSlide) zoomSlide.classList.remove('fbk-zoom');
      zoomSlide = null;
    }
    carousel.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !mqFine.matches) return;
      var slide = e.target.closest('.product-gallery__media');
      if (!isImageSlide(slide)) { endZoom(); return; }
      var img = slide.querySelector(':scope > img');
      if (!img) return;
      var r = img.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      if (x < 0 || x > 1 || y < 0 || y > 1) { endZoom(); return; }
      var lens = lensFor(slide);
      if (!lens.fbkReady) {
        var want = Math.round(r.width * ZOOM * Math.min(window.devicePixelRatio || 1, 2));
        lens.style.backgroundImage = 'url("' + hiResUrl(img, want) + '")';
        lens.fbkReady = true;
      }
      var sr = slide.getBoundingClientRect();
      lens.style.left = (r.left - sr.left) + 'px';
      lens.style.top = (r.top - sr.top) + 'px';
      lens.style.width = r.width + 'px';
      lens.style.height = r.height + 'px';
      lens.style.backgroundSize = (ZOOM * 100) + '% auto';
      lens.style.backgroundPosition = (x * 100).toFixed(2) + '% ' + (y * 100).toFixed(2) + '%';
      if (zoomSlide !== slide) { endZoom(); zoomSlide = slide; }
      slide.classList.add('fbk-zoom');
    }, { passive: true });
    carousel.addEventListener('pointerleave', endZoom);
    carousel.addEventListener('scroll', endZoom, { passive: true });

    /* ---- Thumbnails: max 7 (mobiel 5), laatste = "+N" ---- */
    var list = gallery.querySelector('.product-gallery__thumbnail-list');
    function layoutThumbs() {
      if (!list) return;
      var thumbs = Array.prototype.slice.call(list.querySelectorAll('.product-gallery__thumbnail'));
      thumbs.forEach(function (b) {
        b.classList.remove('fbk-thumb--more', 'fbk-thumb--over');
        b.removeAttribute('data-more');
      });
      var visible = thumbs.filter(function (b) { return !b.hidden; });
      var max = mqMobile.matches ? MAX_THUMBS_MOBILE : MAX_THUMBS_DESK;
      if (visible.length <= max) return;
      var more = visible[max - 1];
      more.classList.add('fbk-thumb--more');
      more.setAttribute('data-more', '+' + (visible.length - (max - 1)));
      visible.slice(max).forEach(function (b) { b.classList.add('fbk-thumb--over'); });
    }
    if (list) {
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.fbk-thumb--more');
        if (!btn) return;
        var thumbs = Array.prototype.slice.call(list.querySelectorAll('.product-gallery__thumbnail'));
        var slide = (carousel.items || [])[thumbs.indexOf(btn)];
        if (isImageSlide(slide) && openLightbox(gallery, slide)) e.stopPropagation();
      }, true);
      if (window.MutationObserver) {
        new MutationObserver(layoutThumbs).observe(list, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
      }
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', layoutThumbs);
      layoutThumbs();
    }
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('product-gallery'), setup);
  }

  function start() {
    var ready = window.customElements && customElements.whenDefined
      ? Promise.all([customElements.whenDefined('product-gallery'), customElements.whenDefined('media-carousel')])
      : Promise.resolve();
    ready.then(function () { init(document); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* Theme-editor en sectie-herlaad */
  document.addEventListener('shopify:section:load', function (e) { start(); init(e.target); });
})();
